import request from "../../config/axios";

const loginUser = (data) => {
  return request.post(`/wp-json/custom-auth/v1/login`, data);
};

const registerUser = (data) => {
  const mappedData = {
    username: data.username,
    email: data.email,
    password: data.password,
    first_name: data.firstName, // ← đúng key WordPress cần
    last_name: data.lastName, // ← đúng key WordPress cần
    phone: data.phone, // ← WordPress cần trường phone
  };
  return request.post(`/wp-json/custom-auth/v1/register`, mappedData);
};

const requestPasswordReset = (email) => {
  return request.post(`/wp-json/custom/v1/request-password-reset`, email);
};

const resetPassword = (data) => {
  return request.post(`/wp-json/custom/v1/reset-password`, data);
};

const logoutUser = ()=>{
  return request.post(`/wp-json/custom-auth/v1/logout`)
}

const getAccountProfile = () =>{
  return request.get("/wp-json/custom-auth/v1/check-auth", {
  withCredentials: true
})
}

export { loginUser, registerUser ,requestPasswordReset, resetPassword,getAccountProfile ,logoutUser};
